import { Globe, Zap, Users } from 'lucide-react';
import { Feature } from '../../types';
import styles from './Features.module.css';

interface FeaturesProps {
  title?: string;
  subtitle?: string;
  features?: Feature[];
}

const Features = ({
  title = 'Experience the Universe',
  subtitle = 'Discover what makes Cosmos Horizon the ultimate space adventure',
  features = [
    {
      id: 'exploration',
      icon: 'globe',
      title: 'Open Universe Exploration',
      description: 'Discover infinite procedurally generated galaxies. Each journey brings new worlds, mysterious phenomena, and untold treasures waiting to be found.'
    },
    {
      id: 'combat',
      icon: 'zap',
      title: 'Epic Space Combat',
      description: 'Engage in intense tactical battles with customizable starships. Master advanced weaponry and outmaneuver your enemies in zero-gravity warfare.'
    },
    {
      id: 'multiplayer',
      icon: 'users',
      title: 'Multiplayer Campaigns',
      description: 'Team up with friends or compete against players worldwide. Form alliances, wage wars, and leave your mark on the cosmos together.'
    }
  ]
}: FeaturesProps) => {
  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'globe':
        return Globe;
      case 'zap':
        return Zap;
      case 'users':
        return Users;
      default:
        return Globe;
    }
  };

  return (
    <section id="features" className={styles.features}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>

        {/* Feature Cards */}
        <div className={styles.grid}>
          {features.map((feature, index) => {
            const IconComponent = getIconComponent(feature.icon);
            return (
              <article
                key={feature.id}
                className={styles.card}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={styles.iconWrapper}>
                  <IconComponent className={styles.icon} size={32} />
                  <div className={styles.iconGlow} />
                </div>

                <h3 className={styles.cardTitle}>{feature.title}</h3>

                <p className={styles.description}>{feature.description}</p>

                <div className={styles.cardOverlay} />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
